import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { ProductReviewsState, ProductReviewsDispatch } from './store';

export const useProductReviewsDispatch = (): ProductReviewsDispatch =>
  useDispatch<ProductReviewsDispatch>();
export const useProductReviewsSelector: TypedUseSelectorHook<ProductReviewsState> =
  useSelector;
